const sortByName = (a, b, sortMode) => {
  if (sortMode === "descending") {
    return (`${  b.name}`).localeCompare(a.name);
  }
  return (`${  a.name}`).localeCompare(b.name);
};

const sortByInt = prop => (a, b, sortMode) => {
  if (sortMode === "descending") {
    // eslint-disable-next-line radix
    return parseInt(b[prop]) - parseInt(a[prop]);
  }
  // eslint-disable-next-line radix
  return parseInt(a[prop]) - parseInt(b[prop]);
};

const sortByFloat = prop => (a, b, sortMode) => {
  if (sortMode === "descending") {
    return parseFloat(b[prop]) - parseFloat(a[prop]);
  }
  return parseFloat(a[prop]) - parseFloat(b[prop]);
};

const sortByDate = prop => (a, b, sortMode) => {
  if (sortMode === "descending") {
    return new Date(b[prop]) - new Date(a[prop]);
  }
  return new Date(a[prop]) - new Date(b[prop]);
};

export default {
  sortByName,
  sortByInt,
  sortByFloat,
  sortByDate,
};